<header id="page-topbar" class="bg-dark shadow-sm" style="height: 70px">
  <div class="navbar-header">
    <div class="d-flex">
      <!-- LOGO -->
      <div class="navbar-brand-box">
        <a
          routerLink="/home/dashboard"
          class="logo logo-dark"
          (click)="onLogoClick($event)"
        >
          <span class="logo-sm">
            <img src="assets/images/Growthlooplogopng.png" alt="" height="24" />
          </span>
          <span class="logo-lg">
            <img src="assets/images/Growthlooplogopng.png" alt="" height="68" />
          </span>
        </a>

        <a
          routerLink="/home/dashboard"
          class="logo logo-light"
          (click)="onLogoClick($event)"
        >
          <span class="logo-sm">
            <img src="assets/images/Growthlooplogopng.png" alt="" height="24" />
          </span>
          <span class="logo-lg">
            <img src="assets/images/Growthlooplogopng.png" alt="" height="68" />
          </span>
        </a>
      </div>

      <button
        type="button"
        class="btn btn-sm px-3 font-size-16 header-item"
        id="vertical-menu-btn"
        (click)="toggleMobileMenu($event)"
      >
        <i class="fa fa-fw fa-bars"></i>
      </button>

      <!-- App Search-->
      <!-- <form class="app-search d-none d-lg-block">
        <div class="position-relative">
          <input
            type="text"
            class="form-control form-group search"
            placeholder="Search..."
          />
          <button class="btn" type="button" style="background-color: #3275a2">
            <i class="bx bx-search-alt align-middle text-white"></i>
          </button>
        </div>
      </form> -->
      <form
        class="app-search d-none d-lg-block"
        (submit)="onSearchSubmit($event)"
      >
        <div class="position-relative">
          <input
            type="text"
            class="form-control form-group search"
            placeholder="Search..."
            [(ngModel)]="searchParam"
            name="searchParam"
            (input)="onSearchInput()"
            (keydown.enter)="onSearchSubmit($event)"
            (blur)="onSearchBlur()"
            autocomplete="off"
          />
          <button
            class="btn"
            type="button"
            style="background-color: #3275a2"
            (click)="triggerSearch()"
          >
            <i class="bx bx-search-alt align-middle text-white"></i>
          </button>

          <!-- Dropdown Results -->
          <div
            *ngIf="
              (searchResults.length > 0 || isSearching) && showSearchDropdown
            "
            style="
              position: absolute;
              top: 100%;
              left: 0;
              width: 650px;
              z-index: 99999;
              background: #ffffff;
              border: 1px solid #dee2e6;
              border-radius: 8px;
              box-shadow: 0 4px 20px rgba(0, 0, 0, 0.12);
              max-height: 620px;
              overflow-y: auto;
              margin-top: 4px;
            "
          >
            <!-- Loading -->
            <div
              *ngIf="isSearching"
              style="padding: 10px 14px; font-size: 0.82rem; color: #888"
            >
              Searching...
            </div>

            <!-- Results -->
            <div
              *ngFor="let item of searchResults; let i = index"
              (click)="onSearchResultClick(item)"
              [style.background]="i % 2 === 0 ? '#ffffff' : '#f8f9fc'"
              style="
                padding: 8px 14px;
                border-bottom: 1px solid #f0f0f0;
                cursor: pointer;
                transition: background 0.15s;
              "
              onmouseover="this.style.background = '#e8f0fe'"
              onmouseout="this.style.background = ''"
            >
              <div
                style="
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                "
              >
                <div
                  style="font-size: 0.84rem; font-weight: 500; color: #2c2c2c"
                >
                  {{
                    item.source === "MENU"
                      ? item.name
                      : item.source === "Account"
                        ? item.ledgerName
                        : item.source === "Stock"
                          ? item.ledgerName
                          : item.name
                  }}
                </div>

                <!-- Balance for Account / LedgerInfo -->
                <div
                  *ngIf="
                    (item.source === 'Account' ||
                      item.source === 'LedgerInfo') &&
                    item.balance
                  "
                  style="
                    font-size: 0.75rem;
                    font-weight: 500;
                    padding: 1px 8px;
                    border-radius: 10px;
                    white-space: nowrap;
                  "
                  [style.background]="+item.balance < 0 ? '#fdecea' : '#eaf6ee'"
                  [style.color]="+item.balance < 0 ? '#dc3545' : '#198754'"
                >
                  {{ item.balance }}
                </div>

                <!-- Balance for Stock -->
                <div
                  *ngIf="item.source === 'Stock' && item.balance"
                  style="
                    font-size: 0.75rem;
                    font-weight: 500;
                    padding: 1px 8px;
                    border-radius: 10px;
                    white-space: nowrap;
                  "
                  [style.background]="+item.balance < 0 ? '#fdecea' : '#eaf6ee'"
                  [style.color]="+item.balance < 0 ? '#dc3545' : '#198754'"
                >
                  {{ item.balance }}
                </div>
              </div>

              <div style="font-size: 0.71rem; color: #999; margin-top: 3px">
                <span *ngIf="item.source === 'Menu'" matTooltip="Menu">
                  ☰
                </span>
                <span
                  *ngIf="item.source === 'Account'"
                  matTooltip="Ledger Report"
                  >📒 Account<span *ngIf="item.mobileNo">
                    · {{ item.mobileNo }}</span
                  ></span
                >
                <span
                  *ngIf="item.source === 'LedgerInfo'"
                  matTooltip=" Edit Ledger Info"
                  >✏️ LedgerInfo
                  <span *ngIf="item.ledgerCode">
                    · Code: {{ item.ledgerCode }}</span
                  >
                  <span *ngIf="item.mobileNo"> · {{ item.mobileNo }}</span>
                  <span *ngIf="item.panNo"> · PAN: {{ item.panNo }}</span>
                  <span *ngIf="item.balance"> · Bal: {{ item.balance }}</span>
                </span>
                <span *ngIf="item.source === 'SKU'" matTooltip=" Edit SKU Info"
                  >✏️ SKU
                  <span *ngIf="item.skuCode"> · Code: {{ item.skuCode }}</span>
                  <span *ngIf="item.balance"> . {{ item.balance }}</span>
                </span>
                <span *ngIf="item.source === 'Stock'" matTooltip="Stock Report">
                  <i
                    class="bx bx-package"
                    style="color: #7c3aed; font-size: 0.95rem"
                  ></i>
                  Stock · {{ item.skuName }}
                </span>
                <span
                  *ngIf="
                    item.source !== 'MENU' &&
                    item.source !== 'Account' &&
                    item.source !== 'Stock' &&
                    item.source !== 'LedgerInfo' &&
                    item.source !== 'SKU'
                  "
                >
                  {{ item.source }}
                </span>
                <span *ngIf="item.branch"> · Branch: {{ item.branch }}</span>
                <span *ngIf="item.godown"> · Godown: {{ item.godown }}</span>
                <span *ngIf="item.businessStation">
                  · Station: {{ item.businessStation }}</span
                >
                <span *ngIf="item.agent"> · Agent: {{ item.agent }}</span>
                <span *ngIf="item.area"> · Area: {{ item.area }}</span>
              </div>
            </div>

            <!-- No results -->
            <div
              *ngIf="searchResults.length === 0 && !isSearching"
              (mousedown)="$event.preventDefault()"
              style="padding: 10px 14px; font-size: 0.82rem; color: #888"
            >
              No results found.
            </div>
          </div>
        </div>
      </form>
    </div>

    <div class="d-flex">
      <div class="dropdown d-inline-block d-lg-none ms-2" ngbDropdown>
        <button
          type="button"
          class="btn header-item"
          id="page-header-search-dropdown"
          data-bs-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
          ngbDropdownToggle
        >
          <i-feather name="search" class="icon-lg"></i-feather>
        </button>
        <div
          class="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
          aria-labelledby="page-header-search-dropdown"
          ngbDropdownMenu
        >
          <form class="p-3">
            <div class="form-group m-0">
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Search ..."
                  aria-label="Search Result"
                />

                <button class="btn btn-primary" type="submit">
                  <i class="mdi mdi-magnify"></i>
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>

      <!-- <div class="dropdown d-none d-sm-inline-block" ngbDropdown>
                <button type="button" class="btn header-item" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" ngbDropdownToggle>
                    @if(flagvalue === undefined){
                    <img src="{{valueset}}" alt="Header Language" height="16">}
                    @else {
                    <img src="{{flagvalue}}" alt="Header Language" height="16">
                    }
                </button>
                <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
                    @for (item of listLang; track $index) {
                    <a href="javascript:void(0);" class="dropdown-item notify-item" (click)="setLanguage(item.text, item.lang, item.flag)" [ngClass]="{'active': cookieValue === item.lang}">
                        <img src="{{item.flag}}" alt="user-image" class="me-1" height="12"> <span class="align-middle">{{item.text}}</span>
                    </a>
                    }
                </div>
            </div> -->
      <!-- Centered Company Info -->

      <!-- <div
        class="text-center d-none d-lg-block position-absolute top-50 start-50 translate-middle"
        style="z-index: 1; width: max-content"
      > -->
      <div
        class="text-center d-none d-lg-block position-absolute top-50 start-50 translate-middle"
        style="width: max-content"
      >
        <div class="fw-bold fs-5" style="color: #3275a2">
          {{ getCompanyName() }}
          <ng-container *ngIf="getBranchName()">
            (Branch - {{ getBranchName() }})
          </ng-container>
        </div>
        <!-- <div class="fst-italic fs-6 fw-medium text-muted" *ngIf="getCompanyStartDate() && getCompanyEndDate()"
          [matTooltip]="getCompanyNEStartDate() + ' to ' + getCompanyNEEndDate()"> -->
        <!-- {{getStorageName()}} ({{ getCompanyStartDate() | date : "dd/MM/yyyy" }} to
          {{ getCompanyEndDate() | date : "dd/MM/yyyy" }}) -->
        <!-- {{getStorageName()}} ({{ fyStartDate | date : "dd/MM/yyyy" }} to
          {{ fyEndDate| date : "dd/MM/yyyy" }})
        </div> -->

        <div
          class="fst-italic fs-6 fw-medium text-muted"
          *ngIf="getCompanyStartDate() && getCompanyEndDate()"
          [matTooltip]="companyDateRangeTooltip"
        >
          {{ getStorageName() }} ({{ getCompanyNEStartDate() }} to
          {{ getCompanyNEEndDate() }})
        </div>

        <div
          class="fw-medium fs-6"
          style="color: #a23232"
          *ngIf="getlicenseDay() <= 20 && getlicenseDay() != 0"
        >
          License expires in {{ getlicenseDay() }} days
        </div>
      </div>

      <!-- md only: show only company name and branch (no date) -->
      <div class="text-center d-none d-md-block d-lg-none py-3">
        <div class="fw-bold fs-5" style="color: #3275a2">
          {{ getCompanyName() }}
          <ng-container *ngIf="getBranchName()">
            (Branch - {{ getBranchName() }})
          </ng-container>
        </div>
      </div>

      <div class="dropdown d-none d-sm-inline-block">
        <button
          type="button"
          class="btn header-item"
          id="mode-setting-btn"
          [matTooltip]="'Toggle Theme'"
        >
          <ng-container *ngIf="layoutMode === 'light'">
            <i-feather
              name="moon"
              class="feather-grid icon-lg"
              (click)="changeMode('dark')"
              style="color: #3275a2"
            ></i-feather>
          </ng-container>
          <ng-container *ngIf="layoutMode === 'dark'">
            <i-feather
              name="sun"
              class="feather-grid icon-lg"
              (click)="changeMode('light')"
              style="color: #ffc107"
            ></i-feather>
          </ng-container>
        </button>
      </div>

      <!-- <div class="dropdown d-none d-lg-inline-block ms-1" ngbDropdown>
                <button type="button" class="btn header-item" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" ngbDropdownToggle>
                    <i-feather name="grid" class="icon-lg"></i-feather>
                </button>
                <div class="dropdown-menu dropdown-menu-lg dropdown-menu-end" ngbDropdownMenu>
                    <div class="p-2">
                        <div class="row g-0">
                            <div class="col">
                                <a class="dropdown-icon-item" href="javascript:void(0)">
                                    <img src="assets/images/brands/github.png" alt="Github">
                                    <span>GitHub</span>
                                </a>
                            </div>
                            <div class="col">
                                <a class="dropdown-icon-item" href="javascript:void(0)">
                                    <img src="assets/images/brands/bitbucket.png" alt="bitbucket">
                                    <span>Bitbucket</span>
                                </a>
                            </div>
                            <div class="col">
                                <a class="dropdown-icon-item" href="javascript:void(0)">
                                    <img src="assets/images/brands/dribbble.png" alt="dribbble">
                                    <span>Dribbble</span>
                                </a>
                            </div>
                        </div>

                        <div class="row g-0">
                            <div class="col">
                                <a class="dropdown-icon-item" href="javascript:void(0)">
                                    <img src="assets/images/brands/dropbox.png" alt="dropbox">
                                    <span>Dropbox</span>
                                </a>
                            </div>
                            <div class="col">
                                <a class="dropdown-icon-item" href="javascript:void(0)">
                                    <img src="assets/images/brands/mail_chimp.png" alt="mail_chimp">
                                    <span>Mail Chimp</span>
                                </a>
                            </div>
                            <div class="col">
                                <a class="dropdown-icon-item" href="javascript:void(0)">
                                    <img src="assets/images/brands/slack.png" alt="slack">
                                    <span>Slack</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div> -->

      <div class="dropdown d-inline-block" ngbDropdown>
        <button
          type="button"
          class="btn header-item noti-icon position-relative"
          id="page-header-notifications-dropdown"
          data-bs-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
          ngbDropdownToggle
        >
          <i-feather name="bell" class="feather-grid icon-lg"></i-feather>
          <span *ngIf="errors.length" class="badge bg-danger rounded-pill">{{
            errors.length
          }}</span>
        </button>

        <div
          class="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
          aria-labelledby="page-header-notifications-dropdown"
          ngbDropdownMenu
          style="
            background-color: #fff8f0;
            box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
          "
        >
          <div class="p-3 border-bottom">
            <div class="row align-items-center">
              <div class="col">
                <h6 class="m-0 text-danger fw-semibold">
                  Please fix the following errors:
                </h6>
              </div>
              <div class="col-auto">
                <a
                  href="javascript:void(0);"
                  class="small text-decoration-underline text-primary"
                >
                  {{ "HEADER.NOTIFICATIONS.VIEW_ALL" | translate }}
                </a>
              </div>
            </div>
          </div>

          <ngx-simplebar style="max-height: 230px; width: 400px">
            <a
              href="javascript:void(0);"
              *ngFor="let error of errors; let i = index"
              class="text-reset notification-item px-3 py-2 border-bottom"
              (click)="setFocusOnErrorControl(i)"
              style="cursor: pointer"
            >
              <div class="d-flex align-items-start">
                <div class="text-danger fw-medium">
                  {{ i + 1 }}. {{ error.message }}
                </div>
              </div>
            </a>
          </ngx-simplebar>

          <div class="p-2 border-top text-center">
            <a class="btn btn-sm btn-outline-primary" href="javascript:void(0)">
              <i class="mdi mdi-arrow-right-circle me-1"></i>
              <span>{{ "HEADER.NOTIFICATIONS.LOAD_MORE" | translate }}</span>
            </a>
          </div>
        </div>
      </div>

      <div class="dropdown d-inline-block me-2">
        <button
          type="button"
          class="btn header-item right-bar-toggle px-2 py-1 rounded"
          (click)="toggleRightSidebar()"
          matTooltip="Settings"
          style="transition: background-color 0.2s ease-in-out"
        >
          <i-feather name="settings" class="icon-lg text-secondary"></i-feather>
        </button>
      </div>

      <div class="dropdown d-inline-block me-2" ngbDropdown>
        <button
          type="button"
          class="btn header-item noti-icon position-relative px-2 py-1 rounded"
          id="page-header-chat-dropdown"
          ngbDropdownToggle
          routerLink="chat"
          matTooltip="Messages"
          style="transition: background-color 0.2s ease-in-out"
        >
          <i-feather
            name="message-square"
            class="feather-grid icon-lg text-secondary"
          ></i-feather>

          <span
            *ngIf="errors.length > 0"
            class="badge bg-danger rounded-pill position-absolute top-0 start-100 translate-middle p-1"
            style="font-size: 0.65rem"
          >
            {{ errors.length }}
          </span>
        </button>
      </div>

      <!-- ── DATE RANGE: right side ── -->
      <div class="d-none d-lg-flex align-items-center me-2">
        <i
          class="fa fa-calendar-alt me-1"
          style="color: #3275a2; font-size: 0.85rem"
        ></i>
        <select
          class="form-select form-select-sm"
          style="width: 130px; font-size: 0.75rem"
          [(ngModel)]="dateRangeTypeId"
          (change)="onddlDateRangeChange(dateRangeTypeId)"
        >
          <option
            *ngFor="let item of dateFilters"
            [value]="item.dataValueField"
          >
            {{ item.dataTextField }}
          </option>
        </select>
      </div>
      <!-- ── END DATE RANGE ── -->

      <div class="dropdown d-inline-block" ngbDropdown>
        <button
          type="button"
          class="btn header-item topbar-light d-flex align-items-center"
          id="page-header-user-dropdown"
          ngbDropdownToggle
          aria-haspopup="true"
          aria-expanded="false"
          data-bs-toggle="dropdown"
        >
          <img
            class="rounded-circle header-profile-user"
            src="assets/images/users/avatar-1.png"
            alt="Header Avatar"
            height="32"
          />
        </button>

        <div
          class="dropdown-menu dropdown-menu-end dropdown-menu-sm"
          ngbDropdownMenu
        >
          <!-- username at top of dropdown -->
          <div class="dropdown-item-text px-3 py-2 border-bottom">
            <div class="d-flex align-items-center gap-2">
              <img
                src="assets/images/users/avatar-1.png"
                class="rounded-circle"
                height="32"
              />
              <div>
                <div class="fw-semibold" style="font-size: 0.85rem">
                  {{ getUserName() }}
                </div>
              </div>
            </div>
          </div>
          <a class="dropdown-item" routerLink="/apps/profile">
            <i class="fa-regular fa-user me-2 text-primary"></i> Profile
          </a>

          <a class="dropdown-item" routerLink="/home/company">
            <i class="fa-regular fa-building me-2 text-secondary"></i> Change
            Company
          </a>

          <a
            class="dropdown-item"
            [routerLink]="['/home/company']"
            [queryParams]="{ branch: true }"
          >
            <i class="fa-regular fa-building me-2 text-secondary"></i> Change
            Branch
          </a>

          <a class="dropdown-item" routerLink="/home/updatepassword">
            <i class="fa fa-key me-2 text-warning"></i> Change Password
          </a>

          <a
            class="dropdown-item"
            routerLink="/account/login"
            (click)="logout()"
          >
            <i class="mdi mdi-lock me-2 text-muted"></i> Lock Screen
          </a>

          <a
            class="dropdown-item"
            href="../../../assets/GrowthLoopTechnologies/Growth_erp/index.html"
            target="_blank"
            rel="noopener"
          >
            <i class="mdi mdi-book me-2 text-info"></i> User Manual & Guide
          </a>

          <div class="dropdown-divider"></div>

          <a
            class="dropdown-item text-danger fw-semibold"
            href="javascript:void(0);"
            (click)="logout()"
          >
            <i class="mdi mdi-logout me-2"></i> Log Out
          </a>
        </div>
      </div>
    </div>
  </div>
</header>
